import { Route } from 'vue-router';
import { SiteLanguageConfig } from '@modules/app/siteLanguage/siteLanguageConfig';

const generateHrefLangTags = (currentURL: string): HTMLLinkElement[] => {
    const alternativeLanguages = SiteLanguageConfig.availableLocales.map(({ value }) => value.toLowerCase()) || [];

    return alternativeLanguages.map((lang) => {
        const hasLanguageSegment = currentURL.match(/\/[a-z]{2}-[a-z]{2}\//i);
        const hrefLangUrl = hasLanguageSegment
            ? currentURL.replace(/\/([a-z]{2}-[a-z]{2})\//i, `/${lang}/`)
            : `/${lang}${currentURL}`;
        const linkElement = document.createElement('link');
        linkElement.setAttribute('rel', 'alternate');
        linkElement.setAttribute('hreflang', lang);
        linkElement.setAttribute('href', `${window.location.protocol}//${window.location.hostname}${hrefLangUrl}`);
        return linkElement;
    });
};

export const persistHrefLangTags = (to: Route):void => {
    if (!(SiteLanguageConfig.hasLocaleInUrls)) {
        return;
    }

    const existingLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');
    existingLinks.forEach((link) => link.parentNode?.removeChild(link));
    const hrefLangLinks = generateHrefLangTags(to.fullPath);
    hrefLangLinks.forEach((link) => document.head.appendChild(link.cloneNode(true)));
};
